import { render } from "./SpellFontSizeConfig.vue?vue&type=template&id=6912534e&scoped=true"
import script from "./SpellFontSizeConfig.vue?vue&type=script&lang=js"
export * from "./SpellFontSizeConfig.vue?vue&type=script&lang=js"

import "./SpellFontSizeConfig.vue?vue&type=style&index=0&id=6912534e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6912534e"]])

export default __exports__